export default "__VITE_ASSET__2Ixu7MtB__"